<template>
  <div class="text-sm flex justify-between items-start text-n-800 dark:text-n-0">
    <div class="flex flex-col">
      <slot>
        <span>
          {{ label }}
          <span v-if="mandatory" class="text-r-500">*</span>
        </span>
      </slot>
      <span v-if="description || $slots.description" class="text-n-400 dark:text-n-500">
        <slot name="description">{{ description }} </slot>
      </span>
    </div>
    <slot name="left"></slot>
  </div>
</template>

<script setup lang="ts">
interface Props {
  /**
   * Label of the form field. As an alternative, you can use the default slot.
   */
  label?: string
  /**
   * Description of the form field placed below the label.
   * As an alternative, you can use the description slot.
   */
  description?: string
  /**
   * If true, a red asterisk will be displayed next to the label.
   * @default false
   */
  mandatory?: boolean
}

withDefaults(defineProps<Props>(), {
  label: '',
  description: undefined,
  mandatory: false
})
</script>
